// RippleButton.js
import React from "react";

const PlainButton = ({ onClick, isLoading, children, type, work_btn, height_btn }) => {
    return (
        <button type={type} className="btn-ripple mbot-btn-secondary center-alignment m-0" onClick={onClick} disabled={isLoading} style={{ width: work_btn && work_btn == "70px" ? "70px" : work_btn && work_btn == "245px" ? "245px" : work_btn && work_btn == "60px" ? "60px" : "max-content", height: height_btn && "48px" }}>
            {children}
        </button>
    );
};

export default PlainButton;
